import React, { useState } from "react";
import {
  DeleteOutlined,
  MenuOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { Button, Card, Image, Input } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { v4 as uuidv4 } from "uuid";
import UnsplashSearch from "./Search";
import useNotebookStore from "../../store/useNotebookStore";

const Editing = ({ refs, notebookId, handleSaveCards, showModal }) => {
  const { cards, setCards, setHasUnsavedChanges } = useNotebookStore();

  const [selectedCardIndex, setSelectedCardIndex] = useState(null);
  const [showUnsplashIndex, setShowUnsplashIndex] = useState(null);

  const { ref3 } = refs;

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(cards);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setCards(items);
    setHasUnsavedChanges(true);
  };

  const handleImageSelect = (imageUrl) => {
    if (selectedCardIndex !== null) {
      const newCards = [...cards];
      newCards[selectedCardIndex].img = imageUrl;
      setCards(newCards);
      setShowUnsplashIndex(null);
      setSelectedCardIndex(null);
      setHasUnsavedChanges(true);
    }
  };

  const handleImageClick = (index) => {
    if (showUnsplashIndex === index) {
      setShowUnsplashIndex(null);
      setSelectedCardIndex(null);
    } else {
      setShowUnsplashIndex(index);
      setSelectedCardIndex(index);
    }
  };

  const handleAddCard = () => {
    const newCard = {
      id: uuidv4(),
      content: "",
      kor: "",
      img: "error",
      audio: "",
    };

    setCards([...cards, newCard]);
    setHasUnsavedChanges(true);
  };

  const handleDeleteCard = (index) => {
    showModal("단어 카드를 삭제하시겠습니까?", () => {
      const newCards = cards.filter((_, i) => i !== index);
      setCards(newCards);
      setHasUnsavedChanges(true);
    });
  };

  const imageSize = window.innerWidth <= 1280 ? 80 : 100;

  return (
    <div className="content cursor-default">
      <div>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="cards" direction="horizontal">
            {(provided) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                className="flex flex-wrap gap-4 w-full relative overflow-hidden"
              >
                {cards.map((card, index) => (
                  <Draggable key={card.id} draggableId={card.id} index={index}>
                    {(provided) => (
                      <>
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className="w-[100%] md:w-[calc(50%-8px)]"
                        >
                          <Card className="h-auto" ref={ref3}>
                            <div className="flex items-center justify-between gap-3">
                              <div className="md:w-[70px] flex items-center justify-between">
                                <MenuOutlined />
                                <div className="line"></div>
                                <p className="num">{String(index + 1).padStart(2, "0")}</p>
                              </div>
                              <div
                                className="cursor-pointer"
                                onClick={() => handleImageClick(index)}
                              >
                                <Image
                                  className={`${
                                    selectedCardIndex === index
                                      ? "border-2 border-[#b2dbf7]"
                                      : ""
                                  } img`}
                                  width={imageSize}
                                  height={imageSize}
                                  src={card.img}
                                  fallback="data:image/png;base64,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"
                                  preview={false}
                                />
                              </div>
                              <div className="flex flex-col gap-3">
                                <Input
                                  type="text"
                                  placeholder="영어 단어"
                                  value={card.content}
                                  onChange={(e) => {
                                    const newCards = [...cards];
                                    const filteredValue =
                                      e.target.value.replace(
                                        /[^a-zA-Zㄱ-힣 .?' -]/g,
                                        ""
                                      );
                                    newCards[index].content = filteredValue;
                                    setCards(newCards);
                                    setHasUnsavedChanges(true);
                                  }}
                                  maxLength={20}
                                />
                                <Input
                                  type="text"
                                  placeholder="뜻"
                                  value={card.kor}
                                  onChange={(e) => {
                                    const newCards = [...cards];
                                    const filteredValue =
                                      e.target.value.replace(
                                        /[^a-zA-Zㄱ-힣,()~\s]/g,
                                        ""
                                      );
                                    newCards[index].kor = filteredValue;
                                    setCards(newCards);
                                    setHasUnsavedChanges(true);
                                  }}
                                  maxLength={20}
                                />
                              </div>
                              <DeleteOutlined
                                onClick={() => handleDeleteCard(index)}
                                className="cursor-pointer text-[18px] text-[#66686B]"
                              />
                            </div>
                          </Card>
                        </div>
                        {showUnsplashIndex === index && (
                          <div className="w-full image-search flex items-center justify-center">
                            <div className="py-5 rounded-lg w-full overflow-auto">
                              <UnsplashSearch
                                onImageSelect={handleImageSelect}
                                initialQuery={card.content}
                              />
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>

      <Button
        onClick={handleAddCard}
        className="w-full mt-5 p-4 text-[#3D90EF] border border-[#3D90EF]"
      >
        <PlusCircleOutlined />
        단어카드 추가하기
      </Button>

      <Button
        onClick={() => handleSaveCards(notebookId)}
        className="w-full mt-3 md:mt-5 p-4 text-[#fff] bg-[#258BFF]"
      >
        저장하기
      </Button>
    </div>
  );
};

export default Editing;
